<template>
  <div>
    <el-dialog
      title="选择命令"
      :visible="commandVisibleProp"
      @close="onClose"
      @open="onOpen"
      width="60%"
      top="5vh"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-card>
        <div class="toolbar">
          <div class="former">
            <el-input
              clearable
              v-model="former['Name:like']"
              placeholder="命令名称"
              @keydown.enter.native="onSubmitQuery"
            >
            </el-input
            >&nbsp;
            <el-button type="primary" @click="onSubmitQuery">
              <i class="fas fa-fw fa-search"></i>
            </el-button>
          </div>
        </div>
        <el-table ref="tb" :data="itemList" v-loading="loading">
          <el-table-column prop="Name" label="命令名称" width="150px">
            <template slot-scope="scope">
              {{ scope.row.Name }}
            </template>
          </el-table-column>
          <el-table-column
            prop="Title"
            label="命令主题"
            width="150px"
          ></el-table-column>
          <el-table-column prop="Payload" label="命令内容">
            <template slot-scope="scope">
              {{ scope.row.Payload }}
            </template>
          </el-table-column>
          <el-table-column
            prop="Desc"
            label="提示说明"
            width="150px"
          ></el-table-column>
          <el-table-column label="操作" width="60px">
            <template slot-scope="scope">
              <el-button
                title="调用"
                size="small"
                type="primary"
                @click="editCommand('use', scope.row)"
              >
                <i class="fas fa-share-square"></i>
              </el-button>
              <!-- <el-button
                title="编辑"
                type="primary"
                @click="editCommand('edit', scope.row)"
              >
                <i class="fas fa-pencil-alt"></i>
              </el-button>
              <el-button
                title="删除"
                type="danger"
                @click="editCommand('del', scope.row)"
              >
                <i class="fas fa-trash-alt"></i>
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>

        <div class="paginator">
          <el-pagination
            @current-change="onChangePage"
            layout="total, prev, pager, next"
            :total="pager.total"
            :current-page="pager.page"
            :page-size="pager.size"
          >
          </el-pagination>
        </div>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    commandVisibleProp: Boolean,
  },
  data() {
    return {
      // 控制命令保存按钮的disable属性
      submitSaveDisable: false,
      formInline: {
        user: "",
        region: "",
      },
      itemList: [],
      former: {
        "Name:like": "",
        BusinessGroup: 1, //业务组类型 0.嵌入式 1.工控，必传0
      },
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      options: [],
      loading: false,
      commandModifyForm: {
        Name: "",
        Payload: "",
      },
      newCommand: {
        Name: "",
        Payload: "",
      },
      commandModifyIndex: -1,
    };
  },
  computed: {
    canSave() {
      return (
        this.submitSaveDisable ||
        !(this.newCommand.Name.trim() && this.newCommand.Payload.trim())
      );
    },
  },
  methods: {

    queryCommandList() {
      this.loading = true;
      this.$axios
        .get("command/list", {
          params: {
            where: _.omit(this.former),
            with: ["CommandGrade"],
            ...this.pager,
            order: ["name"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
          if (this.pager.page > response.data.last) {
            this.pager.page = response.data.last;
            this.queryCommandList();
          }
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 查询
    onSubmitQuery() {
      this.pager.page = 1;
      this.queryCommandList();
    },
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.queryCommandList();
    },
    // 关闭
    onClose() {
      this.$emit("update:commandVisibleProp", false);
      this.$refs.tb.clearSelection();
    },
    onOpen() {
      this.queryCommandList();
    },
    editCommand(method, row) {
      if (method === "use") {
        this.$emit("update", row);
        this.onClose();
      } else if (method === "del") {
        this.$confirm("此操作将删除该自定义命令, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.delCommand(row);
          })
          .catch(() => {});
      } else {
        this.commandModifyForm = { Name: row.Name, Payload: row.Payload };
        this.commandModifyIndex = row.ID;
      }
    },
    // 删除
    onDeleteItem(row) {
      this.$confirm("确定要删除此设备吗？", "提示")
        .then(() => this.$axios.delete(`dcidevice/${row.ID}`))
        .then(() => {
          this.queryCommandList();
          this.$message.success("成功删除设备");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    modifyCommandItem() {
      if (this.commandModifyForm.Name && this.commandModifyForm.Payload) {
        const form = { ...this.commandModifyForm };
        form.Payload = form.Payload.trim();
        try {
          const string = form.Payload.replace(/\n/g, "");
          JSON.parse(string);
          this.doModifyCommandItem();
        } catch (error) {
          this.$confirm("输入的命令内容非JSON格式, 是否继续发送?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.doModifyCommandItem();
            })
            .catch(() => {});
        }
      } else {
        this.$message({
          type: "warning",
          message: "命令名称和内容必填",
          duration: 1500,
        });
      }
    },
    // 编辑
    doModifyCommandItem() {
      this.$axios
        .put(`command/${this.commandModifyIndex}`, {
          Name: this.commandModifyForm.Name,
          Payload: this.commandModifyForm.Payload.trim(),
        })
        .then(
          () => {
            this.$message({
              type: "success",
              message: "成功修改命令",
              duration: 1500,
            });
            this.commandModifyIndex = -1;
            this.queryCommandList();
          },
          (response) => {
            this.$sys.alarmResponse(response);
          }
        );
    },
    // 删除
    delCommand(row) {
      this.$axios.delete(`command/${row.ID}`).then(
        () => {
          this.$message({
            type: "success",
            message: "成功删除该条命令",
            duration: 1500,
          });
          this.queryCommandList();
        },
        (response) => {
          this.$sys.alarmResponse(response);
        }
      );
    },
    // 存保自定义命令
    doSaveCommand() {
      // 先将保存按钮diaable，发出请求后恢复
      this.submitSaveDisable = true;
      this.$axios
        .post("command", {
          Name: this.newCommand.Name.trim(),
          Payload: this.newCommand.Payload,
        })
        .then(
          () => {
            this.$message({
              type: "success",
              message: "成功保存自定义命令",
              duration: 1500,
            });
            this.newCommand = { Name: "", Payload: "" };
            this.submitSaveDisable = false;
            this.cancelNewCommand();
          },
          (response) => {
            this.submitSaveDisable = false;
            this.$sys.alarmResponse(response);
          }
        );
    },
  },
};
</script>

<style scoped lang="scss">
.circle-h {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
</style>
